<template>
    <div class="scroll-y custom-scrollbar">
        <ion-row>
            <ion-col size="12" size-md="10" offset-md="1" size-lg="10" offset-lg="1" size-xl="6" offset-xl="3">
                <div class="padding">

                    <div class="text-left mb-20">
                        <div class="text-left mt-10 mb-10">
                          <button class="link" @click="goTo('UserIndex')">
                            <span class="pd-0">&larr; Wróć do profilu</span>
                          </button>
                        </div>
                        <h1 class="h1 mb-0">Edytuj dane</h1>
                        <p>Warunkiem otrzymania przez Ciebie nagród jest uzupełnienie danych.</p>
                        <form class="form form-user-update" @submit.prevent="postUserUpdate">
                            <p class="text-bold">Dane osobowe</p>
                            <div class="form-group">
                                <label>Imię:</label>
                                <input v-model="firstname" :class="{'input-error' : errors.firstname }" type="text"
                                       placeholder="Podaj imię"/>
                                <p class="error" v-if="errors.firstname">
                                    <svg class="voxion">
                                        <use xlink:href="#icon-alert"></use>
                                    </svg>
                                    <span v-text="errors.firstname"></span>
                                </p>
                            </div>
                            <div class="form-group">
                                <label>Nazwisko:</label>
                                <input v-model="lastname" :class="{'input-error' : errors.lastname }" type="text"
                                       placeholder="Podaj nazwisko"/>
                                <p class="error" v-if="errors.lastname">
                                    <svg class="voxion">
                                        <use xlink:href="#icon-alert"></use>
                                    </svg>
                                    <span v-text="errors.lastname"></span>
                                </p>
                            </div>
                            <div class="form-group">
                                <label>Adres e-mail:</label>
                                <input v-model="email" :class="{'input-error' : errors.email }" type="text"
                                       placeholder="np. adres@mail.pl"/>
                                <p class="error" v-if="errors.email">
                                    <svg class="voxion">
                                        <use xlink:href="#icon-alert"></use>
                                    </svg>
                                    <span v-text="errors.email"></span>
                                </p>
                            </div>
                            <div class="form-group">
                                <label>Numer rachunku bankowego:</label>
                                <p class="text-gray-light text-small">
                                    Potrzebujemy Twój numer, żeby przekazać bonusy przydzielane za realizację zadań w aplikacji.</p>
                                <masked-input
                                        type="text"
                                        :class="{'input-error' : errors.iban }"
                                        v-model="iban"
                                        :mask="ibanMask"
                                        :guide="true"
                                        :showMask="false"
                                        placeholder="Podaj swój 26 cyfrowy numer konta"
                                        placeholderChar="_">
                                </masked-input>
                                <p class="error" v-if="errors.iban">
                                    <svg class="voxion">
                                        <use xlink:href="#icon-alert"></use>
                                    </svg>
                                    <span v-text="errors.iban"></span>
                                </p>
                            </div>
                            <hr/>
                            <p class="text-bold mb-0">Dane adresowe</p>
                            <p class="text-gray-light text-small">
                                Na podany przez Ciebie adres, będziemy wysyłać nagrody, które będziesz mógł wygrać w aplikacji.</p>
                            <div class="form-group">
                                <label>Ulica i numer:</label>
                                <input v-model="place" :class="{'input-error' : errors.place }" type="text"
                                       placeholder="Podaj ulicę i numer"/>
                                <p class="error" v-if="errors.place">
                                    <svg class="voxion">
                                        <use xlink:href="#icon-alert"></use>
                                    </svg>
                                    <span v-text="errors.place"></span>
                                </p>
                            </div>
                            <div class="form-group">
                                <label>Kod pocztowy:</label>
                                <masked-input
                                        type="text"
                                        :class="{'input-error' : errors.zipCode }"
                                        v-model="zipCode"
                                        :mask="[/\d/, /\d/, '-', /\d/, /\d/, /\d/]"
                                        :guide="true"
                                        :showMask="false"
                                        placeholder="np. 60-123"
                                        placeholderChar="_">
                                </masked-input>
                                <p class="error" v-if="errors.zipCode">
                                    <svg class="voxion">
                                        <use xlink:href="#icon-alert"></use>
                                    </svg>
                                    <span v-text="errors.zipCode"></span>
                                </p>
                            </div>
                            <div class="form-group">
                                <label>Miasto:</label>
                                <input v-model="city" :class="{'input-error' : errors.city }" type="text"
                                       placeholder="Podaj miasto"/>
                                <p class="error" v-if="errors.city">
                                    <svg class="voxion">
                                        <use xlink:href="#icon-alert"></use>
                                    </svg>
                                    <span v-text="errors.city"></span>
                                </p>
                            </div>
                            <hr/>
                            <p class="text-bold mb-0">Wybór formy prawnej</p>
                            <p class="text-gray-light text-small">Zaznacz odpowiednie pole:</p>
                            <div class="form-group">
                                <!--<label>Jestem osobą fizyczną:</label>-->
                                <div class="mt-05 mb-10">
                                    <ion-radio-group @ionChange="changeRadioValue($event)">
                                        <ion-item lines="none">
                                            <ion-label class="label">
                                                <label>Prowadzę działalność gospodarczą</label>
                                                <p class="text-gray-light text-small" style="white-space: normal">
                                                    Rozliczam się samodzielnie, zdobyte nagrody zgłoszę do swojej
                                                    księgowości.</p>
                                            </ion-label>
                                            <ion-radio mode="md"
                                                       slot="start"
                                                       value="1"
                                                       :checked="entrepreneur === '1'"
                                                       style="margin-top:0px">
                                            </ion-radio>
                                        </ion-item>
                                        <ion-item lines="none">
                                            <ion-label class="label">
                                                <label>Nie prowadzę działalności gospodarczej</label>
                                                <p class="text-gray-light text-small" style="white-space: normal">
                                                    Otrzymam PIT po zakończeniu roku kalendarzowego, w którym zostaną
                                                    uwzględnione zdobyte przeze mnie nagrody.</p>
                                            </ion-label>
                                            <ion-radio mode="md"
                                                       slot="start"
                                                       value="0"
                                                       :checked="entrepreneur === '0'"
                                                       style="margin-top:0px">
                                            </ion-radio>
                                        </ion-item>
                                    </ion-radio-group>
                                </div>
                            </div>
                            <div v-if="entrepreneur === '0'">
                                <hr/>
                                <p class="text-bold mb-0">Dane podatnika</p>
                                <p class="text-gray-light text-small">
                                    Będą niezbędne do wystawienia PIT za otrzymane nagrody.</p>
                                <div class="form-group">
                                    <label>Data urodzenia:</label>
                                    <masked-input
                                            type="text"
                                            :class="{'input-error' : errors.birthday }"
                                            v-model="birthday"
                                            :mask="[/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/]"
                                            :guide="true"
                                            :showMask="false"
                                            placeholder="np. 1980-01-01"
                                            placeholderChar="_">
                                    </masked-input>
                                    <p class="error" v-if="errors.birthday">
                                        <svg class="voxion">
                                            <use xlink:href="#icon-alert"></use>
                                        </svg>
                                        <span v-text="errors.birthday"></span>
                                    </p>
                                </div>
                                <div class="form-group">
                                    <label>PESEL:</label>
                                    <masked-input
                                            type="text"
                                            :class="{'input-error' : errors.pesel }"
                                            v-model="pesel"
                                            :mask="[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]"
                                            :guide="true"
                                            :showMask="false"
                                            placeholder="np. 69010615763"
                                            placeholderChar="_">
                                    </masked-input>
                                    <p class="error" v-if="errors.pesel">
                                        <svg class="voxion">
                                            <use xlink:href="#icon-alert"></use>
                                        </svg>
                                        <span v-text="errors.pesel"></span>
                                    </p>
                                </div>
                                <div class="form-group">
                                    <label>Nazwa urzędu skarbowego:</label>
                                    <input v-model="taxOfficeName" :class="{'input-error' : errors.taxOfficeName }"
                                           type="text" placeholder="Podaj nazwę urzędu skarbowego"/>
                                    <p class="error" v-if="errors.taxOfficeName">
                                        <svg class="voxion">
                                            <use xlink:href="#icon-alert"></use>
                                        </svg>
                                        <span v-text="errors.taxOfficeName"></span>
                                    </p>
                                </div>
                                <div class="form-group">
                                    <label>Adres urzędu skarbowego:</label>
                                    <input v-model="taxOfficeAddress"
                                           :class="{'input-error' : errors.taxOfficeAddress }"
                                           type="text" placeholder="Podaj adres urzędu skarbowego"/>
                                    <p class="error" v-if="errors.taxOfficeAddress">
                                        <svg class="voxion">
                                            <use xlink:href="#icon-alert"></use>
                                        </svg>
                                        <span v-text="errors.taxOfficeAddress"></span>
                                    </p>
                                </div>
                            </div>
                            <notification v-if="notification" :type="notificationType" :text="notificationText"></notification>
                            <button class="btn btn-primary" type="submit" :disabled="loading">
                                <span v-if="loading"><span class="loader"></span></span>
                                <span v-else>Zapisz zmiany</span>
                            </button>
                        </form>
                    </div>

                </div>
            </ion-col>
        </ion-row>
    </div>
</template>

<script>
    // IBAN: PL83 1010 1023 0000 2613 9510 0000
    // PESEL: 69010615763

    import {mapFields} from 'vuex-map-fields';
    import MaskedInput from 'vue-text-mask'
    import notification from '../../components/Notification'
    import api from '@/services/Api';

    export default {
        name: 'UserEdit',
        components: {MaskedInput, notification},
        data() {
            return {
                loading: false,
                errors: [],
                ibanMask: ['P', 'L', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
                // notification
                notification: false,
                notificationType: 'success',
                notificationText: '',
            }
        },
        computed: {
            ...mapFields([
                'profile.firstname',
                'profile.lastname',
                'profile.email',
                'profile.iban',
                'profile.place',
                'profile.zipCode',
                'profile.city',
                'profile.entrepreneur',
                'profile.birthday',
                'profile.pesel',
                'profile.taxOfficeName',
                'profile.taxOfficeAddress'
            ]),
        },
        methods: {
            goTo(name) {
              this.$router.push({name: name})
            },
            changeRadioValue(event) {
                this.entrepreneur = event.detail.value
            },
            postUserUpdate() {
                this.loading = true;
                let data = this.$store.getters.getProfile
                api.post('/api/v1/user/updateandreturnerrors', data)
                    .then(response => {
                        this.loading = false;
                        this.errors = [];
                        if (response.data.code === 200) {
                            // notification
                            this.notification = true
                            this.notificationType = 'success'
                            this.notificationText = response.data.message
                        }
                    }).catch(err => {
                        this.loading = false;
                        if (err.response && err.response.data)
                            this.errors = err.response.data.errors ? err.response.data.errors : [];
                        if (err.response.status === 400) {
                            // notification
                            this.notification = true
                            this.notificationType = 'error'
                            this.notificationText = err.response.data.message
                        }
                        if (err.response.status === 500) {
                            // toast
                            this.$ionic.toastController
                                .create({
                                    message: 'Błąd serwera.',
                                    duration: 2000,
                                    mode: 'md'
                                })
                                .then(a => a.present());
                        }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>

    ion-item {
        --min-height: 10px;
        --padding-start: 0;
        --padding-end: 0;
        --inner-padding-start: 0;
        --inner-padding-end: 0;
    }

    .label {
        font-size: 13px;
    }

</style>
